import("./bootstrap").catch((err) => {
  if (err?.name === "ChunkLoadError" || err?.message?.includes("Loading chunk")) {
    const reloadKey = "chunk_error_reload";
    const lastReload = sessionStorage.getItem(reloadKey);
    const now = Date.now();
    // Only auto-reload once every 10 seconds to prevent infinite loops
    if (!lastReload || now - Number(lastReload) > 10000) {
      sessionStorage.setItem(reloadKey, String(now));
      window.location.reload();
    }
  }
});
